module.exports = __webpack_public_path__ + "img/xcp.493868e3.svg";